<template>
    <div id="home-wrapper" v-bind:style="[!$kmsTheme ? null : nightModeActive ? $kmsTheme.styles.darkHome : $kmsTheme.styles.lightHome, bgStyles]" v-bind:class="{'app-night-mode': nightModeActive , 'app-light': !nightModeActive}">
        <home-page-content :noticeBoard="noticeBoard" :messages="messages"></home-page-content>
    </div>
</template>

<script>
    import Vue from 'vue';
    import HomePageContent from './home-page-content';
    import moment from 'moment';

    Vue.component('home-page-content', HomePageContent);

    export default {
        data() {
            return {
                noticeBoard: {},
                messages: {},
                bgStyles: {},
                nightModeStartTime: null,
                nightModeEndTime: null,
                currentTime: Date.now()
            }
        },
        props: {
            previewMessageId: {}
        },
        watch: {
            'noticeBoard.nightModeAutoSwitch': function (autoNightMode) {
                if (autoNightMode)
                    this.loadNightModeTimes();
            }
        },
        computed: {
            nightModeActive() {
                if (!this.noticeBoard.nightModeAutoSwitch)
                    return this.noticeBoard.nightMode
                else {
                    if (this.currentTime > this.nightModeEndTime && this.currentTime < this.nightModeStartTime)
                        return false;
                    else
                        return true;
                        
                }
            }
        },
        methods: {
            addUpdateMessage: function (message) {
                console.log("add update message recieved - " + JSON.stringify(message));
                var index = this.messages.findIndex(m => m.noticeMessageId == message.noticeMessageId);
                if (index != -1) {
                    this.$set(this.messages, index, message)
                } else {
                    this.messages.push(message);
                }
            },
            addNoticePicture: function (picture) {
                console.log("add picture recieved");
                if (picture.noticeMessageId) {

                    var index = this.messages.findIndex(m => m.noticeMessageId == picture.noticeMessageId);
                    if (index != -1) {
                        var updatedMessage = this.messages[index];
                        if (updatedMessage.pictures != null) {
                            var noticeBoardPicIndex = updatedMessage.pictures.findIndex(p => p.noticePictureId == picture.noticePictureId);
                            if (noticeBoardPicIndex == -1) {
                                updatedMessage.pictures.push(picture);
                            }
                        } else {
                            updatedMessage.pictures = [picture]
                        }
                        this.$set(this.messages, index, updatedMessage)
                    } else {
                        console.log("notice message with not found with id - " + picture.noticeMessageId);
                    }
                } else {
                    var newNoticeBoard = this.noticeBoard;
                    if (newNoticeBoard.pictures != null) {
                        var noticeBoardPicIndex = newNoticeBoard.pictures.findIndex(p => p.noticePictureId == picture.noticePictureId);
                        if (noticeBoardPicIndex == -1) {
                            newNoticeBoard.pictures.push(picture);
                        }
                    } else {
                        newNoticeBoard.pictures = [picture]
                    }
                    this.noticeBoard = newNoticeBoard;
                }
            },
            deletePicture: function (noticePictureId) {
                console.log("delete picture recieved - " + noticePictureId);
                var messageIndex = this.messages.findIndex(m => m.pictures != null && m.pictures.length > 0 && m.pictures.findIndex(p => p.noticePictureId == noticePictureId) != -1);
                if (messageIndex != -1) {
                    var message = this.messages[messageIndex];
                    console.log(message);
                    message.pictures = message.pictures.filter(p => p.noticePictureId != noticePictureId);
                    console.log(message);
                    this.$set(this.messages, messageIndex, message);
                } else {
                    console.log("Notice message with picture not found - " + noticePictureId);
                }
            },
            deleteMessage: function (messageId) {
                console.log("delete message recieved - " + messageId);
                this.messages = this.messages.filter(m => m.noticeMessageId != messageId);
            },
            updateNoticeBoard: function (boardConfig) {
                console.log("board config received - " + boardConfig);
                this.noticeBoard = boardConfig;

            },
            filterMessagesToOneMessage: async function () {
                var pmid = this.previewMessageId;
                this.messages = this.messages.filter(function (m) { return m.noticeMessageId == pmid });

                console.log('filtered messages to: ' + this.previewMessageId);

                // Filtered message doesn't exist on this notice board
                if (this.messages.length == 0) {
                    var messageRequest = await this.$http.get("DigitalNoticeBoard/single-message", { params: { id: this.previewMessageId } });
                    this.messages = [messageRequest.data];
                }

                this.messages[0].beginDateTime = null;
                this.messages[0].expiryDateTime = null;
                this.messages[0].recurringPeriod = null;
                this.messages[0].recurringFrequency = null;
                this.messages[0].recurringDay = null;
                this.messages[0].recurringDuration = null;

            },
            syncNoticeMessagesAndPictures: function (noticeMessages) {
                var noticeMessageIds = this.messages.map(m => m.noticeMessageId);
                return { noticeMessageIds };
            },
            setNightModeStart(startTime) {
                this.nightModeStartTime = moment(startTime, "HH:mm");
            },
            setNightModeEnd(endTime) {
                this.nightModeEndTime = moment(endTime, "HH:mm");
            },
            async loadNightModeTimes() {
                var times = (await this.$http.get("DigitalNoticeBoard/night-mode-times")).data;
                this.setNightModeStart(times.item1)
                this.setNightModeEnd(times.item2)
            }
        },
        async created() {
            console.log('home page mounted');

            if (this.$kmsTheme && this.$kmsTheme.backgroundImage != null) {
                var picture = this.$kmsTheme.backgroundImage
                this.bgStyles = { "backgroundImage": "url(" + this.$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type + ")" }
            } else {
                this.bgStyles = null;
            }

            console.log('home page mounted - getting board data and messages');

            var boardData = (await this.$http.get("/authentication/digital-notice-board")).data;
            this.noticeBoard = boardData.data.digitalNoticeBoard;

            this.messages = (await this.$http.get("DigitalNoticeBoard/messages")).data;

            if (this.previewMessageId != null) {
                this.filterMessagesToOneMessage();
            }

            console.log("home page mounted - setup night mode time");

            if (this.noticeBoard.nightModeAutoSwitch) {
                await this.loadNightModeTimes();
            }

            var self = this
            setInterval(function () {
                self.currentTime = Date.now()
            }, 1000)

            console.log('home page mounted - finished');

        },
        mounted() {
            this.$noticeBoardHub.on('NoticeMessageReceive', this.addUpdateMessage);
            this.$noticeBoardHub.on('NoticeMessageDelete', this.deleteMessage);
            this.$noticeBoardHub.on('UpdateBoardConfig', this.updateNoticeBoard);
            this.$noticeBoardHub.on('NoticeMessagePictureReceive', this.addNoticePicture);
            this.$noticeBoardHub.on('DeleteNoticePicture', this.deletePicture);
            this.$noticeBoardHub.on('SyncNoticeMessages', this.syncNoticeMessagesAndPictures);
            this.$noticeBoardHub.on('SetNightModeStart', this.setNightModeStart);
            this.$noticeBoardHub.on('SetNightModeEnd', this.setNightModeEnd);
        }
    }

</script>

<style>
    #app {
        height: 100%;
    }

    .app-night-mode {
        background-color: #333;
        color: #fff;
        height: 100%;
    }

    .app-light {
        background-color: #fff;
        color: #000000;
        height: 100%;
    }

    #home-wrapper {
        height: 100%;
    }
</style>
